import FormPayStubNew from './FormPayStubNew'

export default FormPayStubNew
